export enum ProtestStatusCodes {
    Valid = 'UTM',
    Invalid = 'NTM',
    ValidInvalid = 'U/N'
}
